"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableSearch = _interopRequireDefault(require("./TableSearch.style"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _excluded = ["inputProps", "resultsText", "disabled", "clearable"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TableSearch = function TableSearch(_ref) {
  var inputProps = _ref.inputProps,
    resultsText = _ref.resultsText,
    disabled = _ref.disabled,
    clearable = _ref.clearable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TableSearch["default"], _extends({
    className: "search-wrapper ".concat(otherProps.className ? otherProps.className : '')
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, inputProps, {
    onChange: function onChange(event, type) {
      !disabled && inputProps.onChange(event.target.value, type);
    },
    onKeyUp: function onKeyUp(event) {
      if (event.keyCode === 13) {
        !disabled && inputProps.onSearchSubmit();
      }
    },
    value: inputProps.value,
    icon: "ion-android-search",
    iconClick: function iconClick(type) {
      !disabled && inputProps.onSearchSubmit(type);
    },
    clearable: clearable,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "results-text"
  }, resultsText));
};
TableSearch.defaultProps = {
  resultsText: '',
  disabled: false,
  clearable: true
};
TableSearch.propTypes = {
  disabled: _propTypes["default"].bool,
  clearable: _propTypes["default"].bool,
  /** Table search input props */
  inputProps: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onSearchSubmit: _propTypes["default"].func.isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired,
  /** The text for results found */
  resultsText: _propTypes["default"].string
};
TableSearch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableSearch",
  "props": {
    "resultsText": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The text for results found",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "clearable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "inputProps": {
      "description": "Table search input props",
      "type": {
        "name": "shape",
        "value": {
          "onChange": {
            "name": "func",
            "required": true
          },
          "onSearchSubmit": {
            "name": "func",
            "required": true
          },
          "value": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};
var _default = TableSearch;
exports["default"] = _default;